import React from 'react';
import 'react-awesome-slider/dist/styles.css';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'shards-react';
import './WelcomeModal.scss';

const WelcomeModal = ({ closeModal, user, isNewUser, history }) => {
  const handleAction = e => {
    //console.log(e);
    history.push('/dashboard/profile');
    closeModal();
  };
  return (
    <Modal
      className='col-md-8 col-lg-8'
      open={true}
      toggle={closeModal}
      modalClassName='modal'
      fade={true}
      role='dialog'
    >
      <ModalHeader className='text-dark bg-primary1'> Welcome</ModalHeader>
      <ModalBody>
        Hi, there. Before we can start submitting complaints, we require your to
        fill up basic information about yourself. <br /> <br />
        <p>
          <strong>Step 1:</strong> Click on Profile section on the sidebar.
          Update your profile details.
          <br />
          <strong>Step 2:</strong> Click Dashboard section on the sidebar. Click
          Add to lodge a complaint.
          <br />
          <strong>Step 3:</strong> An agent would be assigned to the case.{' '}
          <br />
          <span className='caption'>
            Note: Agent assignment could lead up to 14 days due to high volume
            of complaints.
          </span>
          <br />
          <strong>Step 4:</strong> Agent will communicate with you through
          emails. <br />
          <strong>Step 5:</strong> Agent will advise further actions or close
          the complaint. If you have any doubts, please refer to the guide in
          the Help section. <br />
        </p>
        <span>NCCC</span>
      </ModalBody>
      <ModalFooter className='home-buttons d-flex w-100 justify-content-between px-3'>
        <Button theme='danger' name='dismiss' onClick={closeModal}>
          Dismiss
        </Button>
        <Button
          theme='success'
          name='go_profile'
          onClick={e => handleAction(e)}
        >
          Go To Profile Page
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default WelcomeModal;
